import { apiClient } from '../api/client';

export type StatusDoVip = 'STORED' | 'ACTIVE' | 'PAUSED' | 'FROZEN' | 'EXPIRED' | 'REMOVED';

export interface MeuVip {
  id: string;
  name: string;
  color: string;
  status: StatusDoVip;
  /** Para sempre: não vence. */
  permanent?: boolean;
  remainingSeconds: number;
  /** Conta só com o jogador no servidor: `remainingSeconds` é tempo de jogo, sem data de fim. */
  onlineTime?: boolean;
  expiresAt: string | null;
  endedAt: string | null;
}

export interface OpcaoDeUpgrade {
  vipDefinitionId: string;
  name: string;
  color: string;
  /** Para sempre, ou com o tempo que falta no VIP atual. */
  permanent: boolean;
  /** Em reais (ou na moeda da loja). */
  price: number;
  /** Tempo que vai para o novo (0 no permanente). */
  seconds: number;
}

export interface OfertaDeUpgrade {
  currency: string;
  from: { playerVipId: string; name: string; color: string; permanent: boolean; onlineTime: boolean; remainingSeconds: number } | null;
  options: OpcaoDeUpgrade[];
}

export const vipService = {
  /** VIPs do jogador logado nesta loja (com o módulo VIP desligado, a rota não existe). */
  async meus(storeId: string): Promise<MeuVip[]> {
    const r = await apiClient.get<{ vips: MeuVip[] }>(`/public/stores/${storeId}/players/me/vips`);
    return r.vips ?? [];
  },

  /** Para quais VIPs o VIP que vale agora pode ir, e quanto fica (o servidor calcula). */
  async upgrades(storeId: string): Promise<OfertaDeUpgrade> {
    return apiClient.get<OfertaDeUpgrade>(`/public/stores/${storeId}/players/me/vips/upgrades`);
  },
};

/** "12d 4h", "3h 20min", "45min". */
export function tempoDoVip(segundos: number): string {
  const d = Math.floor(segundos / 86400);
  const h = Math.floor((segundos % 86400) / 3600);
  const m = Math.floor((segundos % 3600) / 60);
  if (d > 0) return h > 0 ? `${d}d ${h}h` : `${d}d`;
  if (h > 0) return m > 0 ? `${h}h ${m}min` : `${h}h`;
  return `${Math.max(1, m)}min`;
}
